import 'components/Dashboards/Project/Components/CustomDashboard/PinboardWidgetWrapper/Narrative/EditNarrative/editNarrative.css';
import React from 'react';
import { IDashboard } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';
import { updateWidgetNarrativeSettings } from 'components/Dashboards/Project/Components/CustomDashboard/customDashboard.utils';
import { DEFAULT_ERROR, useCustomSnackBar } from 'hooks/useCustomSnackBar';
import { ViewNarrative } from 'components/Dashboards/Project/Components/CustomDashboard/PinboardWidgetWrapper/Narrative/ViewNarrative/viewNarrative';
import { EditNarrative } from 'components/Dashboards/Project/Components/CustomDashboard/PinboardWidgetWrapper/Narrative/EditNarrative/editNarrative';
import { useMutationSetDashboardById } from 'components/Dashboards/Project/Components/CustomDashboard/queries/useQuerySetDashboardById';
import { useQueryGetDashboards } from 'components/Dashboards/Project/Components/CustomDashboard/queries/useQueryCustomDashboard';

interface Props {
    isEdit: boolean;
    value: string;
    handleCancel: () => void;
    handleSave: () => void;
    widgetId?: string;
    dashboard?: IDashboard;
}

export const Narrative = ({ isEdit, value, handleCancel, handleSave, widgetId, dashboard }: Props) => {
    const { handleSnackBar } = useCustomSnackBar();
    const { refetch } = useQueryGetDashboards();
    const { mutate: mutateSetDashboardById } = useMutationSetDashboardById();

    const onSave = (description: string, isGenerativeAi: boolean) => {
        if (!dashboard) return;

        const newDashboard = updateWidgetNarrativeSettings({
            dashboard,
            description,
            showGenerativeNarrative: isGenerativeAi,
            widgetId,
        });

        mutateSetDashboardById(
            {
                dashboard: newDashboard,
            },
            {
                onSuccess: () => handleSnackBar('Successfully updated!', 'success'),
                onError: (error) => {
                    DEFAULT_ERROR({ error, handleError: handleSnackBar });
                },
                onSettled: () => {
                    refetch().then(() => handleSave());
                },
            },
        );
    };

    return isEdit ? (
        <EditNarrative value={value} handleCancel={handleCancel} onSave={onSave} />
    ) : (
        <ViewNarrative value={value} />
    );
};
